module.exports = __webpack_public_path__ + "img/menu-icon-3-1.760a90e8.svg";